<template>
  <div class="d-flex justify-content-between w-100 mt-auto">
    <label
      class="d-flex justify-content-center align-items-center mb-0 text-center"
    >
      {{ title }}
    </label>

    <d-button
      type="button"
      class="btn btn-success btn-sm py-1 px-3"
      @click="callCopyText"
    >
      {{ $t('shared.actions.copyText') }}
    </d-button>
  </div>
</template>

<script>
export default {
  name: 'copy-text-title',
  props: {
    title: {
      type: String,
      required: true,
    },
    onCopyText: {
      type: Function,
      required: true,
    },
  },
  methods: {
    callCopyText() {
      this.onCopyText();
    },
  },
};
</script>
